var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSnappay = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M1.492 1.102c-.54 0-.978.34-.978.758v9.33c0 .418.439.758.978.758h17.062c.542 0 .982-.342.982-.762V1.86c0-.418-.44-.758-.982-.758H1.492zm17.062 11.335H1.492c-.808 0-1.467-.559-1.467-1.246V1.86c0-.688.659-1.248 1.467-1.248h17.062c.811 0 1.47.56 1.47 1.247v9.326c0 .69-.659 1.25-1.47 1.25zm-2.358-6.112c-.28 0-.548.074-.775.213a1.542 1.542 0 0 0-.766 1.328c0 .544.292 1.052.761 1.326.233.142.5.215.78.215.85 0 1.541-.69 1.541-1.54 0-.85-.692-1.542-1.541-1.542m0 3.572c-.37 0-.725-.1-1.03-.285a2.029 2.029 0 0 1-1-1.746c0-.716.385-1.386 1.004-1.748a1.97 1.97 0 0 1 1.026-.282c1.12 0 2.03.911 2.03 2.03 0 1.12-.91 2.03-2.03 2.03M.225 3.71h19.566V3.22H.225v.489zm10.093 3.674H1.725a.245.245 0 0 1 0-.489h8.593a.244.244 0 1 1 0 .49M5.975 9.156h-4.25a.244.244 0 1 1 0-.489h4.25a.244.244 0 1 1 0 .49"
}), /*#__PURE__*/React.createElement("path", {
  id: "c",
  d: "M2.39 1.325c-.85 0-1.54.692-1.54 1.541A1.542 1.542 0 0 0 2.813 4.35a2.031 2.031 0 0 1-.647-1.484c0-.566.24-1.104.647-1.483a1.511 1.511 0 0 0-.423-.058m0 3.572a2.034 2.034 0 0 1-2.03-2.03c0-1.12.912-2.03 2.03-2.03.37 0 .726.098 1.031.284a.244.244 0 0 1-.004.42 1.54 1.54 0 0 0-.762 1.325c0 .544.292 1.052.762 1.326a.245.245 0 0 1 .004.42 1.98 1.98 0 0 1-1.03.285"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2 5)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#B2B2B2"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#B2B2B2",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#B2B2B2",
  mask: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-2-5h24v24H-2z"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(14 10)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "d",
  fill: "#B2B2B2"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#B2B2B2",
  xlinkHref: "#c"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#B2B2B2",
  mask: "url(#d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-14-10h24v24h-24z"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSnappay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/snappay.7877498362f8c509039d425d3f7c22de.svg";